<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-map-pin" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">{{ clients.data ? clients.data.length : 0 }} Ward Enrollees</h4>
                <small style="opacity: .8;">Enrollees registered within this ward</small>
              </div>
            </div>
            <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;" @click="show = !show">
              <i class="fe mr-1" :class="show ? 'fe-x' : 'fe-edit'"></i>
              {{ show ? 'Close' : 'Bulk Update Sector' }}
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Stat Tiles -->
        <div class="row mb-2">
          <div class="col-md-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                <div class="avatar avatar-md flex-shrink-0">
                  <div class="avatar-title bg-soft-info rounded-circle text-info">
                    <i class="fe fe-users"></i>
                  </div>
                </div>
                <div>
                  <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Basic Healthcare Provision Fund</p>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ clients.bhcpf }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
                <div class="avatar avatar-md flex-shrink-0">
                  <div class="avatar-title bg-soft-secondary rounded-circle text-secondary">
                    <i class="fe fe-users"></i>
                  </div>
                </div>
                <div>
                  <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Equity Program</p>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ clients.sep }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bulk Sector Update -->
        <div class="card table-card shadow mb-4" v-show="show">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-edit" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Bulk Update Sector</p>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group col-md-8 px-0">
              <label class="info-label d-block mb-1">Select Sector</label>
              <select class="form-control" v-model="sector">
                <option value="State Civil Servant Healthcare Plan">State Civil Servant Healthcare Plan</option>
                <option value="Basic Healthcare Provision Fund">Basic Healthcare Provision Fund</option>
                <option value="State Equity Program">State Equity Program</option>
                <option value="Universal Basic Education Healthcare Plan">Universal Basic Education  Healthcare Plan</option>
                <option value="Voluntary Contributors Healthcare Plan">Voluntary Contributors Healthcare Plan</option>
                <option value="Voluntary Contributor">Voluntary Contributor</option>
                <option value="Organized Community Healthcare Plan">Organized Community Healthcare Plan</option>
                <option value="Oganized Private Sector Healthcare Plan">Oganized Private Sector Healthcare Plan</option>
              </select>
            </div>

            <button type="button" class="btn btn-submit px-4" @click="updateSector">
              <i class="fe fe-save mr-1"></i> Update
            </button>
          </div>
        </div>

        <!-- Table Card -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-users text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Ward Enrollees</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th" v-show="show">Marker</th>
                  <th class="table-th">Name</th>
                  <th class="table-th">Contact</th>
                  <th class="table-th">Status</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="enrollee in clients.data" v-bind:key="enrollee.id">
                  <td v-show="show">
                    <input
                      v-model="checked"
                      type="checkbox"
                      :value="enrollee.id"
                      :id="enrollee.id"
                      style="width:18px;height:18px;"
                    />
                  </td>
                  <td class="font-weight-bold">
                    {{ enrollee.firstname }} {{ enrollee.lastname }}
                  </td>
                  <td>{{ enrollee.phone_number }}</td>
                  <td>
                    <span class="badge badge-soft-secondary">{{ enrollee.sector }}</span>
                  </td>
                  <td>
                    <router-link :to="{ path: '/client/' + enrollee.id }">
                      <button type="button" name="button" class="btn btn-sm btn-outline-secondary">
                        <i class="fe fe-eye"></i>
                      </button>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!clients.data || !clients.data.length">
                  <td :colspan="show ? 5 : 4" class="text-center py-5 text-muted">
                    <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                    <p class="mt-2 mb-0">No enrollees found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      user:null,
      clients:"",
      edit:false,
      show:false,
      sector:"",
      checked: [],
      isLoading: false,
      fullPage: true,
      agency_id:""
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/getuserbyward/${this.$route.params.id}`)
                .then(response => {
                    this.clients = response.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  computed:{
    //
  },
  methods:{

    updateSector(){
    if (this.checked.length < 1 || this.sector == '') {
      this.$toasted.error('No enrolleee or sector selected', {position: 'top-center', duration:3000 })

    }
    else {
      this.isLoading = true
        this.axios.patch(`/api/v1/auth/change-sector-bulk`,{
          sector: this.sector,
          id_list: this.checked,
        })
                    .then(response => {
                        console.log(response)
                        this.getUsers()
                        this.$toasted.success('Enrollees Changed Successfully', {position: 'top-center', duration:3000 })
                        this.isLoading = false
                        this.show = false

                    })
                    .catch(error => {
                        console.error(error);
                        this.$toasted.error('Error!', {position: 'top-center', duration:3000 })
                        this.isLoading = false

                    })
    }

  },
    getUsers(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getuserbyward/${this.$route.params.id}`)
                  .then(response => {
                      this.clients = response.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    }

  },
  created(){
    // this.getUsers()
  }

}
</script>
<style >
.spacer{
  margin-left:15px;
}
</style>
